<template>
    <div class="template">
        <FooterDesktop class="template__Desktop" />
        <FooterMobile class="template__Mobile" />
    </div>
</template>

<script>
import FooterDesktop from '@/components/footer/FooterDesktop.vue'
import FooterMobile from '@/components/footer/FooterMobile.vue'
export default{
    name:'FooterComponents',
    components: {
        FooterDesktop,
        FooterMobile
    }
}
</script>

<style lang=scss scoped>
.template__Desktop {
    display: none;
}

.template__Mobile {
    display: block;
}

@media screen and (min-width: 1366px) {
    .template__Desktop {
        display: block;
    }

    .template__Mobile {
        display: none;
    }
}
</style>
